module.exports = __webpack_public_path__ + "img/image-5.6874a7e4.png";